<template>
  <vs-popup
    class="holamundo"
    :title="'Histórico Status'"
    :active.sync="popupHistorico"
    @close="popupHistorico = false"
  >
    <div v-if="historico.length > 0 && !carregando">
      <div class="w-full">
        <div class="grid grid-cols-6 p-1">
          <div class="col-span-4 divInfo font-semibold">Código do Evento</div>
          <div class="col-span-2 borderLeft">
            {{ idEvento }}
          </div>
        </div>

        <div class="grid grid-cols-6 bgGray p-1">
          <div class="col-span-4 divInfo font-semibold">
            Qtd Alteração Status
          </div>
          <div class="col-span-2 borderLeft">
            {{ historico.length }}
          </div>
        </div>
      </div>

      <hr class="my-2" />

      <div class="grid grid-cols-12 mt-4 bgGray p-1">
        <div
          class="col-span-1 flex justify-center items-center font-semibold text-right divInfo"
        >
          ID
        </div>

        <div
          class="col-span-4 flex justify-start items-center font-semibold divInfo borderLeft"
        >
          Status do evento
        </div>

        <div
          class="col-span-7 flex justify-start items-center font-semibold divInfo borderLeft"
        >
          Data de criação do evento
        </div>
      </div>
      <div
        v-for="(item, index) in historico"
        :key="index"
        class="grid grid-cols-12 p-2"
        :class="{
          bgGray: index % 2 !== 0,
        }"
      >
        <div class="col-span-1 flex justify-center items-center text-right">
          {{ index + 1 }}
        </div>

        <div class="col-span-4 flex justify-start items-center borderLeft">
          <vs-chip
            :color="item.corStatus"
            class="product-order-status font-bold"
          >
            {{ item.nomeStatusNovo }}
          </vs-chip>
        </div>

        <div class="col-span-7 flex justify-start items-center borderLeft">
          {{ diferencas[index] }}
        </div>
      </div>
    </div>

    <div v-else-if="historico.length === 0 && !carregando">
      <h5 class="my-2">Nenhum histórico encontrado</h5>
    </div>
  </vs-popup>
</template>

<script>
import service from '../../services';

export default {
  name: 'ModalHistoricoPainelEventos',

  props: ['popupActive', 'dadosHistorico'],

  data() {
    return {
      carregando: false,
      popupHistorico: false,
      historico: [],
      diferencas: [],
      MILLISECONDS_IN_A_SECOND: 1000,
      SECONDS_IN_A_MINUTE: 60,
      MINUTES_IN_AN_HOUR: 60,
      MILLISECONDS_IN_AN_HOUR: 3600000,
      MILLISECONDS_IN_A_MINUTE: 60000,
      HOURS_IN_A_DAY: 24,
    };
  },

  watch: {
    dadosHistorico() {
      this.preencheModal();
    },
  },

  methods: {
    async preencheModal() {
      this.popupHistorico = true;
      this.carregando = true;

      const { idEvento, idEventoEnvolvido } = this.dadosHistorico;

      const link = idEventoEnvolvido
        ? `buscar-historico-painel-eventos/eventosEnvolvidos/${idEventoEnvolvido}`
        : `buscar-historico-painel-eventos/eventos/${idEvento}`;

      this.idEvento = idEventoEnvolvido || idEvento;

      const { data } = await service.getAll('logs', null, link);

      if (data.length > 0) {
        this.calcularDiferencaDatas(data);
      }
      this.historico = data;
      this.carregando = false;
    },
    calcularDiferencaDatas(eventos) {
      const diferencas = [];
      const agora = new Date();

      const primeiraData = new Date(eventos[0].dataCriacao.replace('Z', ''));
      diferencas.push(this.calculaQtddeDiasEnviada(primeiraData, agora));

      eventos.slice(1).forEach((evento, i) => {
        const dataAtual = new Date(evento.dataCriacao.replace('Z', ''));
        const dataAnterior = new Date(eventos[i].dataCriacao.replace('Z', ''));
        diferencas.push(this.calculaQtddeDiasEnviada(dataAtual, dataAnterior));
      });

      this.diferencas = diferencas;
    },
    calculaQtddeDiasEnviada(dataInicio, dataFim) {
      const differenceMs = dataFim - dataInicio;

      const totalHours = Math.floor(
        differenceMs / this.MILLISECONDS_IN_AN_HOUR,
      );
      const minutesDifference = Math.floor(
        (differenceMs % this.MILLISECONDS_IN_AN_HOUR) /
          this.MILLISECONDS_IN_A_MINUTE,
      );

      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;

      const daysText = days > 0 ? `${days} dia${days > 1 ? 's' : ''} ` : '';
      const hoursText =
        hours > 0 ? `${String(hours).padStart(2, '0')} horas ` : '';
      const minutesText =
        minutesDifference > 0
          ? `${String(minutesDifference).padStart(2, '0')} minutos`
          : '';

      const result = `${daysText}${hoursText}${minutesText}`;

      return result || 'Menos de um minuto';
    },
    calcularDiferencaEmHorasEMinutos(differenceMilliseconds) {
      const minutesDifference = Math.floor(
        differenceMilliseconds / this.MILLISECONDS_IN_A_MINUTE,
      );
      const hours = Math.floor(minutesDifference / this.MINUTES_IN_AN_HOUR);
      const minutes = minutesDifference % this.MINUTES_IN_AN_HOUR;
      return { hours, minutes };
    },
  },
};
</script>
<style>
.bgGray {
  background-color: rgb(233, 233, 233);
}
.divSubTitle,
.divInfo {
  color: rgb(55, 73, 87);
  text-transform: uppercase;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}
.borderLeft {
  border-left: 1px solid white;
  padding-left: 8px;
}
</style>
